
export function join(items, seperator) {
  let result = items.filter((item) => {return Boolean(item);});
  return result.join(seperator);
}



/** WEBPACK FOOTER **
 ** ./src/components/common/utils.js
 **/